module.exports = __webpack_public_path__ + "img/gallery.2d8d4a49.svg";